import { render, staticRenderFns } from "./accordion.vue?vue&type=template&id=fd9a34c2&scoped=true&"
import script from "./accordion.vue?vue&type=script&lang=ts&"
export * from "./accordion.vue?vue&type=script&lang=ts&"
import style0 from "./accordion.vue?vue&type=style&index=0&id=fd9a34c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9a34c2",
  null
  
)

export default component.exports